var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "rotate(90 15.5 15.5)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9917 17.3977C15.8312 17.4981 15.6505 17.5382 15.49 17.5382C15.3294 17.5382 15.1488 17.4981 14.9882 17.3977L7 12.5205V19.0034C7 20.3883 8.12397 21.5122 9.50885 21.5122H21.4911C22.876 21.5122 24 20.3883 24 19.0034V12.5205L15.9917 17.3977Z",
    fill: "#1E1E1E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4912 8.98828H9.50889C8.32471 8.98828 7.32117 9.83126 7.08032 10.9552L15.5101 16.0934L23.9198 10.9552C23.6789 9.83126 22.6754 8.98828 21.4912 8.98828Z",
    fill: "#1E1E1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/Mail.df460b257cdeb69081e979b3924b9308.svg";
export { ForwardRef as ReactComponent };